import * as React from 'react';
import { Popup } from '@eagerlogic/react-mvc';

export class Dialog extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
    }

    public render() {
        return (
            <Popup onFadeClicked={this.props.onFadeClicked}>
                <div style={{
                    width: (this.props.width ? this.props.width : "600px"),
                    backgroundColor: '#fff',
                    padding: '32px',
                    boxShadow: '1px 1px 20px rgba(0,0,0,0.5)'
                }}>
                    {this.props.title && (
                        <div style={{fontSize: '22px', fontWeight: 900, color: '#333', marginBottom: '32px', textAlign: 'left'}}>{this.props.title}</div>
                    )}
                    {this.props.desc && (
                        <div style={{fontSize: '16px', fontWeight: 400, color: '#aaa', marginBottom: '32px', textAlign: 'center'}}>{this.props.desc}</div>
                    )}
                    {this.props.error && (
                        <div style={{fontSize: '16px', fontWeight: 400, color: '#c00', marginBottom: '32px', textAlign: 'center'}}>{this.props.error}</div>
                    )}
                    {this.props.children}
                </div>
            </Popup>
        );
    }

}

export class Props {

    public width?: string;
    public title?: string;
    public desc?: string;
    public error?: string;
    public children: React.ReactNode;
    public onFadeClicked?: {(): void};

}

export class State {

}